import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { View, Button, Icon } from '@dkrm/ui-kit-basic';
import cStyles, { stylePropTypes } from '@dkrm/general-libs/theme/styles';
import { TOGGLE_STAR_EMPTY, TOGGLE_STAR_FULL, TOGGLE_STAR_HALF } from '@dkrm/ui-kit-basic/Icon/constants';
export default class Rating extends Component {
  constructor(...args) {
    super(...args);
    this.shouldComponentUpdate = nextProps => {
      const {
        value
      } = this.props;
      return value !== nextProps.value;
    };
  }
  onChangeRating(base5Value) {
    const {
      base,
      onChangeRating
    } = this.props;
    const normalizedRatingValue = base === 5 ? base5Value : base5Value * 2;
    return onChangeRating(normalizedRatingValue);
  }
  getNumberOfHalfStars() {
    const {
      base,
      value
    } = this.props;
    const nearestPoint = Math.round(value * 2) / 2;
    if (base === 5) return Math.ceil(nearestPoint % 1);
    return value % 2;
  }
  getNumberOfGreenStars() {
    const {
      base,
      value
    } = this.props;
    const numberOfHalfStars = this.getNumberOfHalfStars();
    const nearestPoint = Math.round(value * 2) / 2;
    if (base === 5) return Math.floor(nearestPoint);
    return Math.floor((value - numberOfHalfStars) / 2);
  }
  renderStarComponent(imageUrl, key) {
    const {
      size,
      theme
    } = this.props;
    return /*#__PURE__*/React.createElement(Icon, {
      key: key,
      name: imageUrl,
      theme: theme,
      size: size
    });
  }
  renderStar(imageUrl, index) {
    const {
      disabled
    } = this.props;
    const StarComponent = this.renderStarComponent(imageUrl, index);
    if (disabled) return StarComponent;
    const base5Value = index + 1;
    return /*#__PURE__*/React.createElement(Button, {
      disabled: disabled,
      key: index,
      onPress: () => this.onChangeRating(base5Value)
    }, StarComponent);
  }
  render() {
    const {
      style
    } = this.props;
    const numberOfHalfStars = this.getNumberOfHalfStars();
    const numberOfGreenStars = this.getNumberOfGreenStars();
    const stars = [];
    for (let i = 0; i < numberOfGreenStars; i += 1) {
      stars.push(TOGGLE_STAR_FULL);
    }
    if (numberOfHalfStars) {
      stars.push(TOGGLE_STAR_HALF);
    }
    for (let i = numberOfGreenStars + numberOfHalfStars; i < 5; i += 1) {
      stars.push(TOGGLE_STAR_EMPTY);
    }
    return /*#__PURE__*/React.createElement(View, {
      style: [cStyles.flexDirRow, style]
    }, stars.map((star, i) => this.renderStar(star, i)));
  }
}
Rating.defaultProps = {
  value: 0,
  size: 20,
  style: null,
  base: 10,
  disabled: true,
  theme: 'tosca',
  onChangeRating: () => null
};
Rating.propTypes = process.env.NODE_ENV !== "production" ? {
  value: PropTypes.number,
  size: PropTypes.number,
  style: stylePropTypes,
  base: PropTypes.oneOf([5, 10]),
  disabled: PropTypes.bool,
  onChangeRating: PropTypes.func,
  theme: PropTypes.string
} : {};